import { editGroupSettingsProp } from 'state/fence/fenceSlice';
import { getCurrentFenceGroup } from 'state/fence/fenceSelector';
import ModalBase from 'components/common/ModalBase/ModalBase';
import FormLabel from 'components/common/FormLabel/FormLabel';
import FormNumber from 'components/common/FormNumber/FormNumber';
import FormCheck from 'components/common/FormCheck/FormCheck';
//import TooltipBase from 'components/common/TooltipBase/TooltipBase';
import ButtonBase from 'components/common/ButtonBase/ButtonBase';
import { ReactComponent as IconAsc } from 'assets/img/icons/asc.svg';
import { ReactComponent as IconDesc } from 'assets/img/icons/desc.svg';
import { useDispatch, useSelector } from 'react-redux';

const ModalStarterSettings = () => {
  const dispatch = useDispatch();
  const currentFenceGroup = useSelector(getCurrentFenceGroup);
  const settings = currentFenceGroup.settings;

  const changeMaxWidthHandler = (value) => {
    dispatch(editGroupSettingsProp({ prop: 'maxWidth', value }));
  };

  const changeSlopeSizeCmHandler = (value) => {
    dispatch(editGroupSettingsProp({ prop: 'slopeSizeCm', value }));
  };

  const changeSlopeDirectionHandler = (value) => {
    dispatch(editGroupSettingsProp({ prop: 'slopeDirection', value }));
  };

  const enableReadyToDesign = () => {
    dispatch(editGroupSettingsProp({ prop: 'readyToDesign', value: true }));
  };

  return (
    <ModalBase title="Tervezett kerítés méretei">
      <div className="row align-items-center mb-md">
        <div className="col-6">
          <FormLabel>Kerítés maximum husszúsága:</FormLabel>
        </div>
        <div className="col-6 d-flex align-items-center">
          <FormNumber
            defaultValue={settings.maxWidth}
            onChange={changeMaxWidthHandler}
            step="10"
            min="100"
            max="10000"
            unit="cm"
            typeable
          />
        </div>
      </div>

      <div className="row align-items-center mb-md">
        <div className="col-6">
          <FormLabel>Terep lejtés mértéke:</FormLabel>
        </div>
        <div className="col-6 d-flex align-items-center">
          <FormNumber
            defaultValue={settings.slopeSizeCm}
            onChange={changeSlopeSizeCmHandler}
            step="5"
            min="0"
            max="1000"
            unit="cm"
            typeable
          />
        </div>
      </div>

      <div className="row align-items-center mb-md">
        <div className="col-6">
          <FormLabel>Terep lejtés iránya:</FormLabel>
        </div>
        <div className="col-6 d-flex align-items-center">
          <div className="row">
            <div className="col-6">
              <FormCheck mode="box"
                type="radio"
                name="slope-direction"
                groupValue={settings.slopeDirection}
                value="asc"
                onChange={changeSlopeDirectionHandler}
              >
                <IconAsc />
              </FormCheck>
            </div>
            <div className="col-6">
              <FormCheck mode="box"
                type="radio"
                name="slope-direction"
                groupValue={settings.slopeDirection}
                value="desc"
                onChange={changeSlopeDirectionHandler}
              >
                <IconDesc />
              </FormCheck>
            </div>
          </div>
        </div>
      </div>

      <hr className="mb-md" />

      <ButtonBase className="w-full" color="primary" onClick={enableReadyToDesign}>
        Tovább a tervezőhöz
      </ButtonBase>
    </ModalBase>
  );
};

export default ModalStarterSettings;
